export const topBarHeight: number = 64;
export const sideNavWidth: number = 260;
export const navbarHeight: number = 60;
export const sidenavCompactWidth: number = 80;
export const containedLayoutWidth: number = 1200;
